import { listItemClasses, Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MuiList(theme: Theme): Components['MuiList'] {
  const listStyle = {
    paddingLeft: theme.spacing(4),
    [`& .${listItemClasses.root}`]: {
      display: 'list-item',
      paddingLeft: theme.spacing(1),
    },
  };

  return {
    variants: [
      {
        props: { 'data-list-style': 'initial' },
        style: {
          listStyle: 'initial',
          ...listStyle,
        },
      },
      {
        props: { 'data-list-style': 'decimal' },
        style: {
          listStyle: 'decimal',
          ...listStyle,
        },
      },
      {
        props: { 'data-list-style': 'square' },
        style: {
          listStyle: 'square',
          ...listStyle,
        },
      },
    ],
    styleOverrides: {
      dense: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
      },
    },
  };
}
